import Announcements from './sections/Announcements';
import MyCourses from './sections/MyCourses';
import CalendarWidget from './sections/CalendarWidget';

export default function StudentInsightPanel() {
  return (
    <div className="insight-panel-inner">
      <Announcements />
      <MyCourses />
      <CalendarWidget />
    </div>
  );
}
